import $ from 'jquery';
import HeroSlider from './blocks/HeroSlider.js';
import ProjectDetail from './blocks/ProjectDetail.js';


$(function () {

    HeroSlider.mount();
    ProjectDetail.mount();


    
    
});